module.exports = __webpack_public_path__ + "static/media/screenshot-1.224817f3.png";